import { RentalState } from '@profile/src/utils/types';
export const options = [{
  label: 'Listing',
  id: RentalState.OWNER_FOR_RENT.toString()
}, {
  label: 'Rented Out',
  id: RentalState.OWNER_RENTED.toString()
}, {
  label: 'De-Listing',
  id: RentalState.OWNER_STOP_FOR_RENT.toString()
}, {
  label: 'Rented',
  id: RentalState.RENTER_RENTED.toString()
}, {
  label: 'Return',
  id: [RentalState.RENTER_RETURN, RentalState.OWNER_RETURN].join('-')
}];